/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_MOST_RECENT_PICOS_AUDIT_STATS = gql`
  query MostRecentStats($storeId: ID!) {
    mostRecentPicosAuditStats(storeId: $storeId) {
      auditDate
      executeDenom
      executeNum
      sellDenom
      sellNum
      averageCompliance
      correctPricingPercentage
      numDisplaysWithOos
    }
  }
`
